// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
   firebase: {
    apiKey: "AIzaSyBfcVoRDYGBg1lvHHoU7baP-UDPmHSRNDU",
    authDomain: "anns-1007e.firebaseapp.com",
    databaseURL: "https://anns-1007e.firebaseio.com",
    projectId: "anns-1007e",
    storageBucket: "anns-1007e.appspot.com",
    messagingSenderId: "671189175293"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts